<template>
  <div class="page-content content-area">
    <services-hot-line v-model="showFlag" />
    <template v-if="status==2">
        <img class="status-icon" src="@/assets/html5/icon_result_pending@2x.png" alt="pending">
        <p class="nav-spec">Your application is still in progress.</p>
    </template>
    <template v-else-if="status==3">
        <img class="status-icon" src="@/assets/html5/icon_result_success@2x.png" alt="success">
        <p class="nav-spec">Your application has been approved.</p>
    </template>
    <template v-else-if="status==4">
        <img class="status-icon" src="@/assets/html5/icon_result_declined@2x.png" alt="declined">
        <p class="nav-spec">Your application has been declined.</p>
    </template>
    <div class="userid" v-if="status==2 || status==3">
      <p class="userid-title">Your User ID is</p>
      <p class="userid-content">{{merchantId}}</p>
    </div>
    <p v-if="status==3" class="description">Kindly check your nominated email for your password, agreements, clauses, and applicable fees that may entail this application.</p>
    <p class="description">For any concerns, please contact our <span class="hotline" @click="showHotline">Merchant Service Hotline</span></p>
    <!-- <BottomButton :showDefaultBtn="false" :mode="pageMode" label="Okay" @click="goBackAppIndex"/> -->
  </div>
</template>

<script>
import ServicesHotLine from "../components/ServicesHotLine";

export default {
  name: 'CheckMidProcessStatus',
  pRouter: 'CheckMidProcess',
  components: {
    ServicesHotLine,
  },
  data(){
    return {
      showFlag: false,
    }
  },
  computed: {
    status: function () {
      return this.$route.params.status
      // return 2
    },
    merchantId: function () {
      return this.$route.params.merchantId
      // return '000000000'
    }
  },
  methods: {
    showHotline: function () {
      this.showFlag = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-content {
    text-align: center;
    color: #2C2C2C;

    .status-icon {
      margin: 10px 0 35px;
      width: 77px;
    }
    
    .nav-spec {
      margin-top: 0;
      font-size: 32px;
      font-weight: bold;
      color: #2C405A;
      letter-spacing: 0.16px;
      margin-bottom: 38px;
    }

    .userid{
      width: 380px;
      background: #E5F5FF;
      padding: 24px 0 26px 0;
      text-align: center;
      border-radius: 8px;
      margin: 0 auto 30px auto;
      margin-bottom: 30px;

      &-title {
        font-size: 16px;
      }

      &-content {
        font-size: 24px;
        font-weight: bold;
        margin-top: 5px;
      }
    }
    
    .description{
      width: 608px;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.08px;
      margin: 0 auto 30px auto;
    }

    .contact{
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.08px;
    }

    .hotline{
      font-weight: bold;
      color: #61C0FA;
      cursor: pointer;
    }
  }
</style>